import { render, staticRenderFns } from "./SysUserAgentModal.vue?vue&type=template&id=247b2457&scoped=true"
import script from "./SysUserAgentModal.vue?vue&type=script&lang=js"
export * from "./SysUserAgentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b2457",
  null
  
)

export default component.exports